import { SOURCE_TYPE_TO_CONSOLE_PROVIDER } from '../../../../../domain/console-source-providers';
import { SourceType } from '../../../../../typings/Integration.interface';

/**
 * Resolve the Console sample provider key for a source's type, but only when it maps to a
 * provider that actually exists in the available providers list — otherwise return undefined
 * so the caller keeps its current selection. Lets the webhook samples auto-select the right
 * provider when a source has a pinned type.
 *
 * Uses the canonical Source Type ↔ Console provider mapping in
 * `domain/console-source-providers.ts` (shared with the server), falling back to a lowercase
 * transform for source types that aren't in the map but happen to match a provider key.
 */
export const resolveSampleProvider = (
  source_type: string | undefined | null,
  available_providers: string[] | undefined,
): string | undefined => {
  if (!source_type || !available_providers) {
    return undefined;
  }
  const candidate =
    SOURCE_TYPE_TO_CONSOLE_PROVIDER[source_type.toUpperCase() as SourceType] ||
    source_type.toLowerCase();
  return available_providers.includes(candidate) ? candidate : undefined;
};
